import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useWeekDays = () => {
  const { i18n } = useTranslation();
  const [weekDays, setWeekDays] = useState<
    { shortName: string; fullName: string; rruleIndex: number }[]
  >([]);

  useEffect(() => {
    const currentLocale = i18n.language.toLowerCase();
    dayjs.locale(currentLocale);

    const firstDayOfWeek = dayjs.localeData().firstDayOfWeek();
    const days = [...Array(7)].map((_, i) => {
      const dayIndex = (i + firstDayOfWeek) % 7;
      return {
        rruleIndex: dayjs().day(dayIndex).day() === 0 ? 6 : dayjs().day(dayIndex).day() - 1, // rrulejs index with monday being 1
        shortName: dayjs().day(dayIndex).format('ddd'),
        fullName: dayjs().day(dayIndex).format('dddd'),
      };
    });

    setWeekDays(days);
  }, [i18n.language]);

  return weekDays;
};

export default useWeekDays;
